import { GridColumn as Column, Grid, GridCustomCellProps } from "@progress/kendo-react-grid";
import { Loader } from "@progress/kendo-react-indicators";
import { useEffect, useMemo, useState } from "react";
import LocalDateOnlyCell from "../../components/cells/LocalDateOnlyCell";
import { fetchApi } from "../../services/api";
import dayjs from "../../utils/dayjs-setup";

type StatusHistoryItem = {
  OwnerNumber?: string;
  ModifiedByUserNumber?: string;
  RetiredDateTime?: Date | null;
  HiredDateTime?: Date | null;
  ModifiedDateTime: Date;
};

type Props = {
  endpoint: string;
};

const AssetStatusHistoryGrid = ({ endpoint }: Props) => {
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState<StatusHistoryItem[]>([]);

  useEffect(() => {
    let isCancelled = false;

    setLoading(true);
    fetchApi(endpoint)
      .then((data: unknown) => {
        if (isCancelled) return;

        let items: StatusHistoryItem[] = [];

        if (Array.isArray(data)) {
          items = data as StatusHistoryItem[];
        } else if (data && typeof data === 'object' && 'Data' in data) {
          const typed = data as { Data?: StatusHistoryItem[] };
          if (Array.isArray(typed.Data)) {
            items = typed.Data;
          }
        }

        setHistory(items);
        setLoading(false);
      })
      .catch(err => {
        if (!isCancelled) {
          alert(err);
          setLoading(false);
        }
      });

    return () => {
      isCancelled = true;
    };
  }, [endpoint]);

  const hasData = useMemo(() => history.length > 0, [history]);

  const ModifiedDateTimeCell = (props: GridCustomCellProps) => {

    const desc = `${dayjs.utc(props.dataItem.ModifiedDateTime).tz("America/New_York").format("MM/DD/YYYY HH:mm")} - ${props.dataItem?.ModifiedByUserNumber ?? ''}`

    return <td {...props.tdProps}>{desc}</td>;
  };

  return <>
    {loading && <div className="k-pos-absolute k-top-center mt-5">
      <Loader type="converging-spinner" />
    </div>}
    {hasData && <Grid
      className='mt-2'
      data={history}
      pageable={false}
      sortable={false}
    >
      <Column field="ModifiedDateTime" title="Driver Profile Modified Date" cells={{ data: ModifiedDateTimeCell }} />
      <Column field="HiredDateTime" title="Driver Hired Date" cells={{ data: LocalDateOnlyCell }} />
      <Column field="RetiredDateTime" title="Driver Retired Date" cells={{ data: LocalDateOnlyCell }} />
      <Column field="OwnerNumber" title="Owner Assignment" />
    </Grid>}
    {!loading && !hasData && <div className="text-center p-3">No status history found.</div>}
  </>;
};

export default AssetStatusHistoryGrid;